import { RX } from './constants/rx';
import {
    COMPLETE_REGISTRATION,
    CREATE_MANHEIM_ACCOUNT
} from './constants/resources';
import {
    FLEX_GENERAL_ERROR_CODE,
    ENDPOINT_UNAVAILABLE_ERROR_CODE,
    SF_ACCOUNT_EXISTS_ERROR_CODE
} from './constants/errorCodes';
import { LANDING_CONTENT_TYPES } from './constants/landingContentTypes';

import { getContentTemplate } from './utils';

import { isEmpty } from 'lodash';

const {
    flex,
    FlexApiRequest
} = window;

const showErrors = (handledErrors, closeTime = 10000) => {
    handledErrors.forEach((handledError) => {
        flex.addPageAlerts({
            summary: handledError.summary,
            selfCloseTimeout: closeTime
        });
    });
};

flex.onTrigger(RX.COMPLETE_REGISTRATION.CLEAR_BRANCH, () => {
    flex.setStore({
        completeRegistration: {}
    });
});

flex.onTrigger(RX.COMPLETE_REGISTRATION.GET_ORG_USER_BY_TOKEN, (registrationToken) => {
    const payload = {
        registrationToken: decodeURIComponent(registrationToken)
    };

    FlexApiRequest.POST({ path: '/api/v1/org/getorguserbyregistrationtoken' })
        .send(payload)
        .then((response) => {
            const { userHasManheimAccount } = response.data;
            flex.setStore({
                completeRegistration: { userHasManheimAccount }
            });

            if (userHasManheimAccount) {
                flex.addPageAlerts({
                    summary: decodeURIComponent(COMPLETE_REGISTRATION.USER_HAS_MANHEIM_ACCOUNT_MSG),
                    className: 'alert-info',
                    selfCloseTimeout: 10000
                });
            }
        })
        .catch(({ handledErrors }) => {
            showErrors(handledErrors, 45000);

            flex.setStore({
                completeRegistration: {
                    registrationTokenNotFound: true
                }
            });
        })
        .finally(() => {
            const { completeRegistration = {} } = flex.getStore();

            flex.setStore({
                completeRegistration: {
                    ...completeRegistration,
                    userRegistrationInformationIsLoading: false
                }
            });
        });
});

flex.onTrigger(RX.COMPLETE_REGISTRATION.SIGN_IN_WITH_MANHEIM_ACCOUNT, (registrationToken) => {
    flex.setBusy(RX.COMPLETE_REGISTRATION.SIGN_IN_WITH_MANHEIM_ACCOUNT, true);
    const payload = {
        registrationToken: decodeURIComponent(registrationToken)
    };

    FlexApiRequest.POST({ path: '/api/v1/org/getorguserbyregistrationtoken' })
        .send(payload)
        .then((response) => {
            const { orgUser } = response.data;
            const params = {
                appUserId: orgUser.user.id,
                userOrgId: orgUser.org.id,
                state: '',
                isOauthCallbackRegistration: true
            };
            FlexApiRequest.POST({ path: '/api/v1/auth/getidploginurl' })
                .send(params)
                .then((response) => {
                    const { loginUrl } = response.data;
                    flex.redirect(loginUrl);
                })
                .catch(({ handledErrors }) => {
                    showErrors(handledErrors);
                });
        })
        .then(() => {
            flex.setBusy(RX.COMPLETE_REGISTRATION.SIGN_IN_WITH_MANHEIM_ACCOUNT, false);
        })
        .catch(({ handledErrors }) => {
            showErrors(handledErrors, 45000)
        });
});

flex.onTrigger(RX.COMPLETE_REGISTRATION.VERIFY_WITH_AUCTION_ACCESS, (registrationToken) => {
    flex.redirect(`/verifyauctionaccess/${registrationToken}`);
});

flex.onTrigger(RX.COMPLETE_REGISTRATION.CREATE_NEW_ACCOUNT, (registrationToken) => {
    flex.redirect(`/createnewaccount/${registrationToken}`);
});

flex.onTrigger(RX.VERIFY_AUCTION_ACCESS.CLEAR_BRANCH, () => {
    flex.setStore({
        verifyAuctionAccess: {
            wasInviteExpired: false
        }
    });
});

flex.onTrigger(
    RX.VERIFY_AUCTION_ACCESS.SUBMIT_FORM,
    (auctionAccessId, governmentIssuedId, registrationToken) => {
        flex.setBusy(RX.VERIFY_AUCTION_ACCESS.SUBMIT_FORM, true);

        const payload = {
            auctionAccessId,
            lastFourOfSocial: governmentIssuedId,
            registrationToken: decodeURIComponent(registrationToken)
        };

        FlexApiRequest.POST({ path: '/api/v1/org/verifyauctionaccess' })
            .send(payload)
            .then((response) => {
                const { userHasManheimAccount } = response.data;
                if (userHasManheimAccount) {
                    flex.redirect(`/completeregistration/${registrationToken}`);
                }
                else {
                    flex.redirect(`/createnewaccount/${registrationToken}/`);
                }
            })
            .catch(({ handledErrors, jqXHR }) => {
                showErrors(handledErrors);

                const { wasInviteExpired } = jqXHR.responseJSON;

                const { verifyAuctionAccess } = flex.getStore().toJS();

                verifyAuctionAccess.wasInviteExpired = wasInviteExpired;

                flex.setStore({
                    verifyAuctionAccess
                });
            })
            .then(() => {
                flex.setBusy(RX.VERIFY_AUCTION_ACCESS.SUBMIT_FORM, false);
            });
    }
);

flex.onTrigger(RX.CREATE_NEW_ACCOUNT.CLEAR_BRANCH, () => {
    flex.setStore({
        createNewAccount: {}
    });
});

flex.onTrigger(RX.CREATE_NEW_ACCOUNT.GET_ORG_USER_BY_TOKEN, (registrationToken) => {
    flex.setBusy(RX.CREATE_NEW_ACCOUNT.GET_ORG_USER_BY_TOKEN, true);

    const payload = {
        registrationToken: decodeURIComponent(registrationToken)
    };

    FlexApiRequest.POST({ path: '/api/v1/org/getorguserbyregistrationtoken' })
        .send(payload)
        .then((response) => {
            const {
                firstName,
                lastName,
                username,
                contactMethods,
                userHasManheimAccount,
                userHasActiveFlexAccount
            } = response.data;
            if (userHasManheimAccount) {
                flex.redirect(`/completeregistration/${registrationToken}`);
            }

            flex.setStore({
                createNewAccount: { personInfo: { firstName, lastName }, username, contactMethods, userHasActiveFlexAccount }
            });
        })
        .catch(() => { }) // no error processing required
        .finally(() => {
            flex.setBusy(RX.CREATE_NEW_ACCOUNT.GET_ORG_USER_BY_TOKEN, false);
        });
});

flex.onTrigger(RX.CREATE_NEW_ACCOUNT.CANCEL, (registrationToken) => {
    flex.redirect(`/completeregistration/${registrationToken}`);
});

flex.onTrigger(
    RX.CREATE_NEW_ACCOUNT.SUBMIT,
    (registrationToken, firstName, lastName, username, password, phone, email) => {
        flex.setBusy(RX.CREATE_NEW_ACCOUNT.SUBMIT, true);

        const payload = {
            registrationToken: decodeURIComponent(registrationToken),
            firstName,
            lastName,
            username,
            password,
            phone,
            email
        };

        FlexApiRequest.POST({ path: '/api/v1/auth/createnewmanheimaccount' })
            .send(payload)
            .then(() => {
                const { createNewAccount } = flex.getStore();

                flex.setStore({
                    createNewAccount: {
                        ...createNewAccount,
                        isFormEditable: false
                    }
                });

                flex.addPageAlerts({
                    summary: CREATE_MANHEIM_ACCOUNT.SUCCESS_MSG,
                    className: 'alert-success',
                    selfCloseTimeout: 30000
                });

                setTimeout(() => flex.redirect(location.origin), 30000);
            })
            .catch(({ handledErrors = [], jqXHR }) => {
                const { userCreationErrors } = jqXHR.responseJSON;
                if (!isEmpty(userCreationErrors)) {
                    const { createNewAccount } = flex.getStore();

                    flex.setStore({
                        createNewAccount: {
                            ...createNewAccount,
                            userCreationErrors
                        }
                    });
                }

                if (handledErrors.some(err => err.code === SF_ACCOUNT_EXISTS_ERROR_CODE)) {
                    flex.addPageAlerts({
                        summary: CREATE_MANHEIM_ACCOUNT.SF_USER_EXISTS_MSG,
                        className: 'alert-warning',
                        selfCloseTimeout: 10000
                    });

                    return;
                }

                const endpointUnavailable = handledErrors.some(err => err.code === ENDPOINT_UNAVAILABLE_ERROR_CODE);
                if (endpointUnavailable) {
                    setTimeout(() => flex.redirect(location.origin), 10000);
                }

                const showGeneralError = handledErrors.some(err => err.code === FLEX_GENERAL_ERROR_CODE);
                if (showGeneralError || endpointUnavailable) {
                    flex.addPageAlerts({
                        summary: CREATE_MANHEIM_ACCOUNT.USER_CREATION_FAILED_MSG,
                        selfCloseTimeout: 45000
                    });
                }

                showErrors(
                    handledErrors.filter(
                        (err) =>
                            ![FLEX_GENERAL_ERROR_CODE, ENDPOINT_UNAVAILABLE_ERROR_CODE].includes(
                                err.code
                            )
                    ),
                    45000
                );
            })
            .finally(() => {
                flex.setBusy(RX.CREATE_NEW_ACCOUNT.SUBMIT, false);
            });
    }
);

flex.onTrigger(RX.CREATE_NEW_ACCOUNT.REMOVE_USERNAME_VALIDATION_ERROR, (userCreationErrors) => {
    if (!isEmpty(userCreationErrors)) {
        const filteredErrors = userCreationErrors.filter((error) => error.property !== 'username');

        const { createNewAccount } = flex.getStore();

        flex.setStore({
            createNewAccount: {
                ...createNewAccount,
                userCreationErrors: filteredErrors
            }
        });
    }
});

flex.onTrigger(RX.CREATE_NEW_ACCOUNT.REMOVE_PHONE_VALIDATION_ERROR, (userCreationErrors) => {
    if (!isEmpty(userCreationErrors)) {
        const filteredErrors = userCreationErrors.filter((error) => error.property !== 'phone');

        const { createNewAccount } = flex.getStore();

        flex.setStore({
            createNewAccount: {
                ...createNewAccount,
                userCreationErrors: filteredErrors
            }
        });
    }
});

flex.onTrigger(RX.LANDING.GET_IMAGE_URL, (orgId, appCode) => {
    flex.setBusy(RX.LANDING.GET_IMAGE_URL, true);

    const payload = {
        orgId,
        appCode
    };

    FlexApiRequest.POST({ path: '/api/v1/org/getlandingpageimages' })
        .send(payload)
        .then((response) => {
            const { imageUrls = [] } = response.data;

            const randomIndex = Math.floor(Math.random() * imageUrls.length);
            const imageSrc = imageUrls[randomIndex];

            const { landing } = flex.getStore();
            flex.setStore({
                landing: {
                    ...landing,
                    imageSrcs: imageUrls,
                    imageSrc
                }
            });
        })
        .catch(({ handledErrors }) => {
            showErrors(handledErrors);
        })
        .finally(() => {
            flex.setBusy(RX.LANDING.GET_IMAGE_URL, false);
        });
});

flex.onTrigger(RX.LANDING.CHANGE_IS_LANDING_MODAL_OPENED, (isModalOpened) => {
    const { landing } = flex.getStore().toJS();
    flex.setStore({
        landing: {
            ...landing,
            isModalOpened
        }
    });
});

flex.onTrigger(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES, (appOrgId, appCode) => {
    flex.setBusy(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES, true);

    const payload = {
        appOrgId,
        contentTypes: [
            LANDING_CONTENT_TYPES.FOOTER,
            LANDING_CONTENT_TYPES.MESSAGE,
            LANDING_CONTENT_TYPES.MODAL
        ]
    };

    FlexApiRequest.POST({ path: '/api/v1/post/getpubliccontenttemplates' })
        .send(payload)
        .then((response) => {
            const { templates = [] } = response.data;

            const footerTemplate = getContentTemplate(
                templates,
                LANDING_CONTENT_TYPES.FOOTER,
                appCode
            );
            const messageTemplate = getContentTemplate(
                templates,
                LANDING_CONTENT_TYPES.MESSAGE,
                appCode
            );
            const modalTemplate = getContentTemplate(
                templates,
                LANDING_CONTENT_TYPES.MODAL,
                appCode
            );

            const { landing } = flex.getStore();
            flex.setStore({
                landing: {
                    ...landing,
                    footerTemplate,
                    messageTemplate,
                    modalTemplate,
                    isModalOpened: modalTemplate && modalTemplate.content
                }
            });
        })
        .catch(({ handledErrors }) => {
            showErrors(handledErrors);
        })
        .finally(() => {
            flex.setBusy(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES, false);
        });
});